import { render, staticRenderFns } from "./RoundPlanningDetailView.vue?vue&type=template&id=68f0ff65&scoped=true"
import script from "./RoundPlanningDetailView.vue?vue&type=script&lang=js"
export * from "./RoundPlanningDetailView.vue?vue&type=script&lang=js"
import style0 from "./RoundPlanningDetailView.vue?vue&type=style&index=0&id=68f0ff65&prod&lang=scss&scoped=true"
import style1 from "./RoundPlanningDetailView.vue?vue&type=style&index=1&id=68f0ff65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0ff65",
  null
  
)

export default component.exports